import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import cx from 'classnames';

import { Logo, PrimaryPanel, InfoPanel, ActionArea, Hamburger } from '../../header-kit';
import SearchContext from './../SearchContext';

import '../Header.scss';

var HeaderMobile = function (_Component) {
  _inherits(HeaderMobile, _Component);

  function HeaderMobile() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HeaderMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HeaderMobile.__proto__ || _Object$getPrototypeOf(HeaderMobile)).call.apply(_ref, [this].concat(args))), _this), _this.isHamburgerActive = function () {
      return _this.props.hamburgerState === 'active';
    }, _this.hasHamburger = function () {
      return _this.props.hamburgerState !== 'hidden';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HeaderMobile, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          headerConfig = _props.headerConfig,
          searchOpen = _props.searchOpen,
          onSearchOpen = _props.onSearchOpen,
          onSearchClose = _props.onSearchClose,
          storeActionAreaRef = _props.storeActionAreaRef,
          collapsed = _props.collapsed,
          shifted = _props.shifted,
          onHamburgerClick = _props.onHamburgerClick;
      var logo = headerConfig.logo,
          actions = headerConfig.actions,
          productNav = headerConfig.productNav,
          search = headerConfig.search,
          info = headerConfig.info;


      var searchContextValue = {
        mobile: true,
        searchHasAdditionalOffset: true
      };

      var headerInfo = info ? React.createElement(
        InfoPanel,
        null,
        info
      ) : null;
      var headerTop = React.createElement(
        PrimaryPanel,
        { narrow: true },
        productNav
      );

      var headerBottom = React.createElement(
        PrimaryPanel,
        { narrow: true },
        React.createElement(
          'div',
          { className: 'sb-header__section sb-header__section--no-shrink' },
          this.hasHamburger() && React.createElement(Hamburger, { open: this.isHamburgerActive(), onClick: onHamburgerClick }),
          logo || React.createElement(Logo, { slot: 'logo', url: '/' })
        ),
        actions.length || search ? React.createElement(
          ActionArea,
          {
            mobile: true,
            actions: actions,
            open: searchOpen,
            onOpen: onSearchOpen,
            onClose: onSearchClose,
            ref: storeActionAreaRef,
            scrollable: true
          },
          search && React.createElement(
            SearchContext.Provider,
            { value: searchContextValue },
            search
          )
        ) : null
      );

      return React.createElement(
        'div',
        {
          className: cx('sb-header', {
            'sb-header--with-info': !!info,
            'sb-header--collapsed': collapsed,
            'sb-header--shifted': shifted
          })
        },
        headerInfo,
        React.createElement(
          'div',
          {
            key: 'st',
            style: { display: 'none' },
            className: 'sb-header__headerTop',
            'data-test-id': 'layout.header-top'
          },
          headerTop
        ),
        React.createElement(
          'div',
          {
            key: 'nd',
            style: { display: 'none' },
            className: cx('sb-header__headerBottom', {
              'sb-header__headerBottom--shifted': shifted
            }),
            'data-test-id': 'layout.header-bottom'
          },
          headerBottom
        )
      );
    }
  }]);

  return HeaderMobile;
}(Component);

export default HeaderMobile;
//# sourceMappingURL=HeaderMobile.js.map